module.exports = __webpack_public_path__ + "img/logo2.a944e4ba.png";